<script lang="ts">
    import { createDialog } from '@melt-ui/svelte';
    import { fade } from 'svelte/transition';
    import type { Writable } from 'svelte/store';

    import { VpCloseIcon } from '@decathlon-experience/icons/svelte';
    import { flyDrawer } from '$saga/utils/customTransitions';
    import { ariaKeyDownA11yHandler } from '$common/utils/ariaKeyDownA11y';

    export let titleLabel: string;
    export let disabled: boolean = false;
    export let isOpen: Writable<boolean> | undefined;
    export let handleOnOutsideClick: () => void = () => undefined;

    const {
        elements: { trigger, title, overlay, content, close, portalled },
        states: { open },
    } = createDialog({
        forceVisible: true,
        open: isOpen,
        onOutsideClick: () => {
            handleOnOutsideClick();
        },
    });
</script>

{#if !disabled}
    <span
        {...$trigger}
        use:trigger
        tabindex="0"
        role="button"
        {...ariaKeyDownA11yHandler(() => {
            $isOpen = true;
        })}
        on:click|stopPropagation={() => {
            $isOpen = true;
        }}
    >
        <slot name="triggerlink" />
    </span>
{:else}
    <span>
        <slot name="triggerlink" />
    </span>
{/if}

{#if $open}
    <div class="" {...$portalled} use:portalled>
        <div
            {...$overlay}
            use:overlay
            class="fixed inset-0 z-40 bg-black/50"
            transition:fade={{ duration: 250 }}
        />
        <div
            {...$content}
            use:content
            class="shadow-lg fixed bottom-0 right-0 z-50 h-[85vh] w-full bg-white transition-all duration-1000 desktop:top-0 desktop:h-screen desktop:min-w-[33vw] desktop:max-w-[33vw]"
            transition:flyDrawer
        >
            <div
                class="sticky flex min-h-[65px] items-center justify-between px-m py-s desktop:px-3xl desktop:py-m"
            >
                <h2 class="text-[22px] font-semibold" {...$title} use:title>
                    {titleLabel}
                </h2>
                <button {...$close} use:close aria-label="Close" class="">
                    <VpCloseIcon class="size-xl" />
                </button>
            </div>

            <section
                class="no-scrollbar h-[calc(85vh_-_65px)] overflow-y-scroll desktop:h-[calc(100vh_-_65px)]"
            >
                <slot />
            </section>
        </div>
    </div>
{/if}
